<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div class="row">
        <div class="col-sm-6">
          <div class="panel">
            <el-page-header @back="$router.go(-1)" content="需求详情">
            </el-page-header>
            <div class="panel-body" v-if="order.id">
              <div>
                <span class="text-main text-semibold">新旧钻头：</span
                >{{ order.is_drill_new == 2 ? '旧钻头' : '新钻头' }}
              </div>
              <template v-if="order.is_drill_new == 2">
                <div>
                  <span class="text-main text-semibold">序列号：</span>
                  <DrillLink :no="order.old_drill_serial_number"></DrillLink>
                </div>
                <div>
                  <span class="text-main text-semibold">维修基地：</span>
                  {{ order.fix_base_name }}
                </div>
              </template>
              <div>
                <span class="text-main text-semibold">钻头类型：</span
                >{{ order.drill_type_name }}
              </div>
              <div>
                <span class="text-main text-semibold">规格：</span
                >{{ order.drill_size }}
              </div>
              <div>
                <span class="text-main text-semibold">型号：</span
                >{{ order.model_number }}
              </div>
              <div>
                <span class="text-main text-semibold">零件号：</span
                >{{ order.component_number }}
              </div>
              <div>
                <span class="text-main text-semibold">数量：</span
                >{{ order.drill_number }}
              </div>

              <!-- <div><span class='text-main text-semibold'>使用地区：</span>{{order.region}}</div> -->
              <div>
                <span class="text-main text-semibold">使用区块：</span
                >{{ order.block_info }}
              </div>
              <div>
                <span class="text-main text-semibold">下料：</span
                >{{ order.cut_info }}
              </div>
              <!-- <div><span class='text-main text-semibold'>地层岩性：</span>{{order.rock_character}}</div>
								<div><span class='text-main text-semibold'>井型：</span>{{order.pit_type}}</div>
								<div><span class='text-main text-semibold'>动力钻具型号：</span>{{order.drill_tool}}</div>
								<div><span class='text-main text-semibold'>排量：</span>{{order.displacement}}</div>
								<div><span class='text-main text-semibold'>泥浆密度：</span>{{order.mud_density}}</div>
								<div><span class='text-main text-semibold'>喷嘴：</span>{{order.nozzle}}</div> -->

              <div class="mar-top">
                <span class="text-main text-semibold">交货紧急程度：</span
                >{{ order.urgent_level_info }}
              </div>
              <div>
                <span class="text-main text-semibold">销售类型：</span
                >{{ order.sale_type_info }}
              </div>
              <div v-if="order.is_drill_new == 2">
                <span class="text-main text-semibold">维修方案：</span
                >{{ order.fix_plan_type }}
              </div>
              <div>
                <span class="text-main text-semibold">喷嘴安装方式：</span
                >{{ order.nozzle_install_info }}
              </div>
              <div>
                <span class="text-main text-semibold">喷嘴：</span
                >{{ order.nozzle }}
              </div>
              <div>
                <span class="text-main text-semibold">包装：</span
                >{{ order.package_type_info }}
              </div>
              <div class="mar-top">
                <span class="text-main text-semibold">备注：</span
                >{{ order.remark }}
              </div>

              <template v-if="order.status > 3">
                <div class="mar-top">
                  <span class="text-main text-semibold">外协厂家：</span
                  >{{ order.factory.name }}
                </div>
                <div>
                  <span class="text-main text-semibold">交货时间：</span
                  >{{ order.deliver_time }}
                </div>
                <!-- <div><span class='text-main text-semibold'>销售类型：</span>{{order.sale_type}}</div>
									<div><span class='text-main text-semibold'>是否带卸扣板：</span>{{order.shackle_plate == 1 ? '是' : '否'}}</div>
									<div><span class='text-main text-semibold'>包装类型：</span>{{order.package_type}}</div> -->
              </template>
              <template v-if="drills.length > 0">
                <hr />
                <h5 class="m-t-20 m-b-10">包含钻头</h5>
                <div class="table-responsive">
                  <table
                    class="table table-striped table-vcenter table-bordered"
                  >
                    <thead>
                      <tr>
                        <th width="5%" class="text-center">序列号</th>
                        <th width="5%" class="text-center">状态</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in drills" :key="item.serial_number">
                        <td class="text-center">
                          <DrillLink :no="item.serial_number"></DrillLink>
                        </td>
                        <td class="text-center">
                          <span
                            class="label"
                            :class="
                              item.status == 1
                                ? 'label-success'
                                : 'label-warning'
                            "
                            >{{ item.status ? '已到达' : '未到达' }}</span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="panel">
            <div class="panel-heading">
              <h3 class="panel-title">操作记录</h3>
            </div>
            <div class="panel-body">
              <p class="col-sm-12" v-if="logs.length == 0">暂无记录</p>
              <div class="timeline" v-else>
                <!-- Timeline header -->
                <!-- <div class="timeline-header">
					                <div class="timeline-header-title bg-success">Now</div>
					            </div> -->
                <div class="timeline-entry" v-for="item in logs" :key="item.id">
                  <div class="timeline-stat">
                    <div class="timeline-icon">
                      <img
                        src="../../../assets/images/avatar.png"
                        alt="Image"
                      />
                    </div>
                    <div class="timeline-time">
                      {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
                    </div>
                  </div>
                  <div class="timeline-label">
                    <p class="text-main text-semibold">
                      <span class="text-info">{{ item.user_name }}</span>
                      {{ item.category_name }}
                    </p>
                    <span v-html="item.content" v-if="item.content"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderShow, orderDrillReceive } from '@/service/getData'

const driilTypeName = {
  2: 'PDC钻头',
  3: '复合钻头',
  4: '矿用钻头',
}

export default {
  data() {
    return {
      order: {},
      logs: [],
      drills: [],
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let id = this.$route.params.id
      if (id) {
        let res = await orderShow(id)
        res.data.drill_type_name = driilTypeName[res.data.drill_type]
        this.order = res.data
        this.logs = res.data.order_logs
        this.drills = res.data.drills
      }
    },
  },
}
</script>

<style scoped>
span.text-semibold {
  margin-right: 10px;
  width: 20%;
  display: inline-block;
  text-align: right;
}
</style>